module.exports = __webpack_public_path__ + "static/one-req-many-res-4-43f24ab10557193c42b13a2d044308b2.png";